'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_ValidationStatus() {
}
export { $c_Ldev_cheleb_scalamigen_ValidationStatus as $c_Ldev_cheleb_scalamigen_ValidationStatus };
$p = $c_Ldev_cheleb_scalamigen_ValidationStatus.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_ValidationStatus;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_ValidationStatus() {
}
export { $h_Ldev_cheleb_scalamigen_ValidationStatus as $h_Ldev_cheleb_scalamigen_ValidationStatus };
$h_Ldev_cheleb_scalamigen_ValidationStatus.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
